<template lang="pug">
  v-slide-y-reverse-transition(group tag="div" class="row" leave-absolute)
    v-col(cols="12" key="heading")
      // Заголовок и действия
      v-list-item(class="pl-0")
        v-list-item-content
          v-list-item-title
            h1(class="mb-2") Курсы на бирже
        v-list-item-action(v-if="isTeacher || isOrganization")
          v-switch(v-model="showMine" :loading="showMineLoading")
            template(v-slot:label)
              span(class="pl-2") Показать мои курсы

      // Блок фильтрации
      course-list-filter-block.mx-3(
        key="filter-block"
        @filters:update="onFiltersUpdate($event)"
        )
    v-col(v-if="loading" v-for="n in 6" xl="3" lg="4" md="6" cols="12"  :key="`sl${n}`")
      v-skeleton-loader(
        class="mx-auto"
        type="article, actions"
      )
    course-card(
      v-for="(course, i) in courses"
      :key="course.id"
      :course="course"
      :isExchange="true"
    )
    v-col(v-if="!courses.length && !loading" key="empty-message" cols="12" class="pa-4" flat)
      p(class="text-center grey--text") Курсы не найдены :(

    // Пагинация
    v-col(v-if="pagination.pageCount > 1" cols="12" key="load-more" class="text-center")
      v-btn(
        @click="loadMore"
        :loading="loadMoreLoading"
        :disabled="!loadMoreAvailable"
      ) Показать еще
        v-icon(right) mdi-chevron-down
    v-pagination(
      v-if="pagination.pageCount > 1"
      class="mb-4"
      key="pagination"
      @input="getAllSellingCoursesList({ page: $event })"
      v-model="pagination.currentPage"
      :length="pagination.pageCount"
      circle
    )

</template>

<script>
import { mapGetters } from 'vuex';

import paginationMixin from '@/mixins/pagination.mixin';
import CourseListFilterBlock from '@/modules/Courses/components/CourseListFilterBlock.vue';
import CourseCard from '@/modules/Courses/components/CourseCard.vue';

export default {
  name: 'CourseList',
  components: {
    CourseListFilterBlock,
    CourseCard,
  },
  mixins: [paginationMixin],
  data: () => ({
    courses: [],
    loading: true,
    showMine: false,
    showMineLoading: false,
    loadMoreLoading: false,
    filters: {},
  }),
  computed: {
    ...mapGetters({
      userData: 'auth/userData',
      userMunicipality: 'auth/userMunicipality',
      isAuthenticated: 'auth/isAuthenticated',
      isStudent: 'auth/isStudent',
      isTeacher: 'auth/isTeacher',
      isOrganization: 'auth/isOrganization',
    }),
  },
  watch: {
    showMine(val) {
      this.showMineLoading = true;
      this.pagination.currentPage = 1;
      if (val) {
        const params = {};
        params['search[owner_id]'] = this.userData.id;
        this.getAllSellingCoursesList(params);
        return;
      }
      this.getAllSellingCoursesList();
    },
  },
  created() {
    this.filters = this.$route.query;
    this.getAllSellingCoursesList();
  },
  methods: {
    getAllSellingCoursesList(params = {}, loadMore = false) {
      if (!params.page) params.page = this.pagination.currentPage;
      if (this.$route.query.organization) {
        params['search[organization]'] = this.$route.query.organization;
      }
      params.expand = 'organizations,edit';
      this.$api.exchange.getAllSellingCoursesList({ ...this.filters, ...params })
        .then((r) => {
          if (!loadMore) this.courses = [];
          this.courses.push(...r.data.data);
          this.fillPaginationData(r.headers);

          this.loading = false;
          this.showMineLoading = false;
          this.loadMoreLoading = false;
        });
    },
    loadMore() {
      this.pagination.currentPage += 1;
      this.loadMoreLoading = true;
      this.getAllSellingCoursesList({}, true);
    },
    onFiltersUpdate(filters) {
      this.filters = filters;
      this.getAllSellingCoursesList();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
